// extracted by mini-css-extract-plugin
export default {"menu":"hamburgerMenu_menu__VZcJ9","open":"hamburgerMenu_open__1RqNb","content":"hamburgerMenu_content__YD7JT"};